module.exports = __webpack_public_path__ + "img/C08TechVanisHasteRM_ua.bf9df030.webp";